import { colors } from '../../colors';
var fiveCard = {
  textColor: colors.ash,
  hoverColor: colors.coral,
  bgColorPara: colors.white,
  bgColor: colors.white,
  cardBgColorB: colors.white,
  cardBgColorHoverB: colors.coral,
  cardCTAColorB: colors.ash,
  cardCTAColorHoverB: colors.white,
  iconColor: colors.coral,
  iconColorHover: colors.white
};
export default fiveCard;